module.exports = function sanitize (value) {
    return value.replace(/\s{2,}/g, ' ').trim()
}